import { ExtendedValence, Valence } from './types';

export function toSimpleValence(valence: ExtendedValence): Valence {
  switch (valence) {
    case ExtendedValence.POSITIVE:
      return Valence.POSITIVE;
    case ExtendedValence.NEGATIVE:
    case ExtendedValence.SMALL_NEGATIVE:
      return Valence.NEGATIVE;
    case ExtendedValence.OTHER:
      return Valence.OTHER;
    default:
      throw Error(`Unknown valence: ${valence}`);
  }
}

export function isImpactCategoryVisible(impactCategoryCode: string) {
  if (impactCategoryCode === 'K5') {
    return false;
  }
  return true;
}
